import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: false,
  complete: false,
  dni: null,
  sexo: null,
  nombres: null,
  apellidos: null,
  fechaNacimiento: null,
  cuil: null,
  contacto: { canContinue: false },
  direccion: { canContinue: false },
  actividad: null,
  rubro: null,
  antiguedad: null,
  ingresos: 0,
  identidadPersonas: null,
  personaSeleccionada: null,
};

const agregarCodeudorSlice = createSlice({
  name: "codeudor",
  initialState,
  reducers: {
    codeudorSetDni: (state, action) => {
      state.dni = action.payload;
      state.complete = false;
    },
    codeudorSetSexo: (state, action) => {
      state.sexo = action.payload;
      state.complete = false;
    },
    codeudorSetEstadoCivil: (state, action) => {
      state.estadoCivil = action.payload;
      state.complete = false;
    },
    codeudorSetContacto: (state, action) => {
      state.contacto = action.payload;
    },
    codeudorSetDireccion: (state, action) => {
      state.direccion = action.payload;
    },
    codeudorFetchIdentidadInited: (state) => {
      state.isLoading = true;
      state.nombres = null;
      state.apellidos = null;
      state.fechaNacimiento = null;
      state.cuil = null;
      state.contacto = { canContinue: false };
      state.direccion = { canContinue: false };
      state.actividad = null;
      state.rubro = null;
      state.antiguedad = null;
      state.ingresos = 0;
      state.complete = false;
      state.identidadPersonas = null;
      state.personaSeleccionada = null;
    },
    codeudorFetchIdentidadCompleted: (state, action) => {
      const response = action.payload;
      const tieneMultiplesPersonas = response.personas?.length > 1;

      state.isLoading = false;
      state.identidadError = false;
      state.complete = false;
      state.identidadPersonas = response;

      if (!tieneMultiplesPersonas) {
        const persona = response.personas?.[0] || response;
        state.nombres = persona.nombres;
        state.apellidos = persona.apellido;
        state.fechaNacimiento = persona.fechaNacimiento;
        state.cuil = persona.cuil;
      }
    },
    codeudorFetchIdentidadFailed: (state) => {
      state.isLoading = false;
      state.identidadError = true;
      state.complete = false;
    },
    codeudorSetPersonaSeleccionada: (state, action) => {
      const persona = action.payload;
      state.personaSeleccionada = persona;
      state.nombres = persona.nombres;
      state.apellidos = persona.apellido;
      state.fechaNacimiento = persona.fechaNacimiento;
      state.cuil = persona.cuil;
      state.complete = false;
    },
    codeudorSetActividad: (state, action) => {
      state.actividad = action.payload;
      state.rubro = null;
      state.antiguedad = null;
      state.complete = false;
    },
    codeudorSetRubro: (state, action) => {
      state.rubro = action.payload;
      state.antiguedad = null;
      state.complete = false;
    },
    codeudorSetAntiguedad: (state, action) => {
      state.antiguedad = action.payload;
      state.complete = false;
    },
    codeudorSetIngresos: (state, action) => {
      state.ingresos = action.payload;
      state.complete = false;
    },
    codeudorSetComplete: (state, action) => {
      state.complete = action.payload;
    },
    codeudorClear: () => initialState,
  },
});

export const {
  codeudorSetDni,
  codeudorSetSexo,
  codeudorSetEstadoCivil,
  codeudorSetContacto,
  codeudorSetDireccion,
  codeudorFetchIdentidadInited,
  codeudorFetchIdentidadCompleted,
  codeudorFetchIdentidadFailed,
  codeudorSetActividad,
  codeudorSetRubro,
  codeudorSetAntiguedad,
  codeudorSetIngresos,
  codeudorSetComplete,
  codeudorClear,
  codeudorSetPersonaSeleccionada,
} = agregarCodeudorSlice.actions;

export const fetchIdentidad = (dni, sexo) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(codeudorFetchIdentidadInited());
      const response = await services.api.getIdentidad(dni, sexo);
      dispatch(codeudorFetchIdentidadCompleted(response));
    } catch (error) {
      dispatch(codeudorFetchIdentidadFailed(error));
    }
  };
};

export default agregarCodeudorSlice.reducer;
